import { createContext, useContext, type RefObject } from "react";

export const DropdownContext = createContext<RefObject<HTMLDivElement | null>>({ current: null });

export function useDropdown(): RefObject<HTMLDivElement | null> {
  return useContext(DropdownContext);
}
